import _minBy from 'lodash/minBy';
import addDays from 'date-fns/addDays';
import { Service, ShipmentType } from '../../types/common';

export const getService = (key: string, services: Service[]): Service | null => {
  return services.find((service) => service.slug === key) || null;
};

export const getQuickestService = (services: Service[]): Service | undefined =>
  _minBy(
    services.filter((service) => !!service.maxDeliveryDays),
    'maxDeliveryDays',
  );

export const getCheapestService = (services: Service[]): Service | undefined =>
  _minBy(services, 'totalRate.amount');

export const getArrivalDate = (maxDeliveryDays = 0): Date => addDays(new Date(), maxDeliveryDays);

export const isShipmentTypeAvailable = (
  originCountry: string,
  shipmentType: ShipmentType,
): boolean => {
  // Only provide document service from HK to ROW
  return !(originCountry !== 'HK' && shipmentType === ShipmentType.DOCUMENT);
};

export const isShipmentDomestic = (
  originCountry?: string,
  destinationCountry?: string,
): boolean => {
  return Boolean(originCountry && destinationCountry && originCountry === destinationCountry);
};
